import * as React from "react";
import {Alert, Box, useTheme} from "@mui/material";
import AgingBadge from "../current_accounts/AgingBadge";

export default function CustomerDebtAlertBanner({debtAlert}) {
    const theme = useTheme();
    const severityByCode = {
        'long_overdue_debt': 'error',
        'high_risk_overdue_debt': 'error',
        'recently_overdue_debt': 'warning',
        'coming_due_debt': 'info',
    };
    const messageByCode = {
        'long_overdue_debt': 'El cliente tiene facturas vencidas hace más de 7 días',
        'high_risk_overdue_debt': 'El cliente tiene facturas vencidas y es de alto riesgo',
        'recently_overdue_debt': 'El cliente tiene facturas vencidas hace poco',
        'coming_due_debt': 'El cliente tiene facturas por vencer en los próximos 7 días',
    };
    return (
        <Alert severity={severityByCode[debtAlert.code]} sx={{marginBottom: '1.5rem'}}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                {messageByCode[debtAlert.code]}
                {debtAlert.worstTier && (
                    <AgingBadge tierCode={debtAlert.worstTier.code} label={debtAlert.worstTier.label} theme={theme}/>
                )}
            </Box>
        </Alert>
    );
}
